import request from "@/utils/request.js";

/**
 * 活动任务列表
 * @returns
 */
export const getMissions = (params) => {
  return request.get("/api/mr/v1/missions", { params });
};

/**
 * 活动任务奖励领取
 * @param {*} params
 * @returns
 */
export const postMissions = (params) => {
  return request.post("/api/mr/v1/missions", params);
};

/**
 * MoonPoint活动积分
 * @returns 
 */
export const getMoonPoint = () => {
  return request.get("/api/mr/v1/moon_point");
}